import { IMAGES } from "@/lib/site";

const lines = [
    "Caring for Country is not a slogan.",
    "It is a responsibility.",
    "It is a knowledge system.",
    "It is an economy.",
    "It is a way of managing land, sea and water that has sustained this continent for at least sixty-five thousand years.",
];

export default function Statement() {
    return (
        <section
            id="statement"
            data-testid="statement-section"
            className="relative py-32 md:py-40 lg:py-56 bg-ink text-bone overflow-hidden grain"
        >
            <img
                src={IMAGES.eucalyptus}
                alt=""
                aria-hidden
                className="absolute inset-0 w-full h-full object-cover opacity-[0.18]"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/85 to-ink" />

            <div className="relative max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid grid-cols-12 gap-6 md:gap-12">
                    <div className="col-span-12 md:col-span-3">
                        <span className="number-mark text-ochre">§ 08</span>
                        <p className="eyebrow text-bone/60 mt-4">Statement</p>
                    </div>

                    <div className="col-span-12 md:col-span-9">
                        <div
                            data-testid="statement-body"
                            className="space-y-6 md:space-y-8"
                        >
                            {lines.map((l, i) => (
                                <p
                                    key={i}
                                    data-testid={`statement-line-${i}`}
                                    className="font-serif text-3xl md:text-4xl lg:text-5xl leading-[1.15] text-bone max-w-4xl"
                                >
                                    {l}
                                </p>
                            ))}
                        </div>

                        <p
                            data-testid="statement-closing"
                            className="mt-16 font-serif italic text-2xl md:text-3xl text-bone/80 max-w-3xl"
                        >
                            The future of seed, restoration and Caring for
                            Country in Australia depends on recognising that
                            truth — and building the infrastructure to support
                            it.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
